import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M150.5 60.8h16.2c10.5 0 19.1 8.8 19.1 19.6v98c0 10.8-8.6 19.6-19.1 19.6H33.3c-10.5 0-19.1-8.8-19.1-19.6v-98c0-10.8 8.6-19.6 19.1-19.6h16.2v-6.9C49.5 25.5 72.4 2 100 2s50.5 23.5 50.5 51.9v6.9zM100 17.7c-19.1 0-35.3 16.7-35.3 36.3v6.9h70.5V54c.1-19.7-16.1-36.3-35.2-36.3zm66.7 164.6c1.9 0 3.8-2 3.8-3.9v-98c0-2-1.9-3.9-3.8-3.9H33.3c-1.9 0-3.8 2-3.8 3.9v98c0 2 1.9 3.9 3.8 3.9h133.4zM93.4 114c0-4.3 2.5-7.5 6.6-7.5 3.3 0 6.6 3.2 6.6 7.5v37.3c0 4.3-2.5 7.5-6.6 7.5h-.8c-3.3 0-5.8-3.2-5.8-7.5V114z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}